import { render, staticRenderFns } from "./m-editKeyword.vue?vue&type=template&id=5d94f8f8&"
import script from "./m-editKeyword.vue?vue&type=script&lang=js&"
export * from "./m-editKeyword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports